// In src/prismic-configuration.js
export const linkResolver = (doc) => {
  // Backup for all other types
  return '/'
}
